import { resolveImage } from "@/lib/image";
import { Link } from "react-router-dom";
import { MapPin, Clock, Instagram, ArrowUpRight } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export default function Footer() {
  const { settings } = useSettings();
  const s = settings || {};
  const address = s.address || "Av. Silvio Avidos, 940 — São Silvano — Colatina/ES";
  const maps = s.maps_url || "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(address);
  const description = (s.footer_description || "Tudo por R$ 20, pertinho de você.").replace(/^É de (?:tirar|Tomar) da mão!\s*/i, "");
  return <footer className="bg-primary text-white border-t-4 border-secondary" data-testid="site-footer">
    <div className="m20-container py-10 sm:py-12">
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-[1.1fr_1.3fr_1fr]">
        <div className="min-w-0">
          <Link to="/" className="inline-flex items-center gap-3 mb-4" aria-label="Mega 20, início">
            {s.logo_url?<img src={resolveImage(s.logo_url)} alt={s.store_name||"MEGA 20"} className="w-44 h-auto rounded-lg"/>:<span className="font-display text-2xl font-bold">{s.store_name||"MEGA 20"}</span>}
          </Link>
          <strong className="block text-secondary text-sm mb-1">É de Tomar da Mão!</strong><p className="text-sm text-background/70 leading-relaxed max-w-xs">{description}</p>
          {s.instagram && <a href={s.instagram} target="_blank" rel="noreferrer" className="inline-flex min-h-11 items-center gap-2 mt-4 text-sm hover:text-secondary"><Instagram size={18}/>Siga nosso Instagram<ArrowUpRight size={15}/></a>}
        </div>
        <div className="min-w-0">
          <h2 className="font-sans font-bold text-sm mb-4 text-secondary">Encontre a Mega 20</h2>
          <p className="text-sm flex items-start gap-3 text-background/80 leading-relaxed"><MapPin size={18} className="shrink-0 mt-0.5"/>{address}</p>
          {s.reference && <p className="text-xs text-background/60 mt-2 ml-7">{s.reference}</p>}
          <a href={maps} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 min-h-11 mt-3 text-sm font-bold hover:text-secondary" data-testid="footer-maps">Como chegar<ArrowUpRight size={16}/></a>
        </div>
        <div className="min-w-0">
          <h2 className="font-sans font-bold text-sm mb-4 text-secondary">Horários da loja</h2>
          <div className="flex items-start gap-3 text-sm text-background/80 leading-relaxed"><Clock size={18} className="shrink-0 mt-0.5"/><div className="space-y-1">
            <p>{s.hours_weekdays || "Segunda a sexta: 08:00 às 18:00"}</p>
            <p>{s.hours_saturday || "Sábado: 08:00 às 13:00"}</p>
            <p>{s.hours_sunday || "Domingo: fechado"}</p>
          </div></div>
        </div>
      </div>
    </div>
    <div className="border-t border-background/10">
      <div className="m20-container py-4 flex flex-wrap items-center justify-between gap-x-6 gap-y-2 text-xs text-background/60">
        <span>© {new Date().getFullYear()} {s.store_name || "MEGA 20"} · Colatina/ES</span>
        <nav aria-label="Links do rodapé" className="flex flex-wrap gap-x-5">
          <Link to="/produtos" className="inline-flex items-center min-h-11 hover:text-secondary">Catálogo</Link>
          <Link to="/loja" className="inline-flex items-center min-h-11 hover:text-secondary">Nossa loja</Link>
        </nav>
      </div>
    </div>
  </footer>;
}
